<template>
    <div class="avatar-uploader-box" style="margin-right: 20px;">
      <el-upload
        class="avatar-uploader"
        :action="action"
        :show-file-list="false"
        :accept="accept"
        :headers="headers"
        :on-success="onSuccess"
        :name="name"
        :before-upload="before"
      >
        <img v-show="imageUrl" :src="imageUrl" class="avatar" id="avatar">
        <div v-show="imageUrl == ''"   class="avatar-uploader-icon"  style="flex-direction: column;justify-content: center;">
            <i class="el-icon-picture" style="margin-top: 1vw;"></i>
        </div>
      </el-upload>
    </div>
  </template>
  <script>
import { Loading } from "element-ui";

  export default {
    name: 'Upload',
    props: {
      accept: { // 限制类型
        type: String,
        default: '.jpg,.jpeg,.png,gif,JPG,JPEG,PNG,GIF'
      },
      action: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      name:{
        type: String,
        default: ''
      },
      title:{
        type: String,
        default: ''
      }
    },
    data() {
      return {
        dialogImageUrl: '',
        dialogVisible: false,
        imageUrl: '',
        fileObj: null,
      headers:{},
      loading:null
      }
    },
    // 监听
    watch: {
      value: {
        handler(newValue, oldValue) {
          // console.log(newValue, '/', oldValue)
          // 分割
          this.imageUrl = newValue
        },
        deep: true,
        immediate: true
      }
    },
    mounted(){
      this.headers = {
        uuid:localStorage.getItem('uuid')
      }
    },
    methods: {
      // 上传前检查
    //   beforeAvatarUpload(file) {
    //     const isLt2M = file.size / 1024 / 1024 < 500
    //     if (!isLt2M) {
    //       this.$message.error('上传头像图片大小不能超过 500KB!')
    //     }
    //     return isLt2M
    //   },
    before(e){
      this.loading =  this.$loading({
        text: "上传图片中，请稍后",
        background: "rgba(0, 0, 0, 0)",
        customClass: "loadinger",
      })

    },
      // 上传成功
      onSuccess(response, file, fileList) {
        console.log(response)
        this.loading.close()
        // 图片地址
        if (response.error === 0) {
          let img = new Image()
          img.src = response.url
          img.onload = ()=>{
            document.getElementById('avatar').style.width = 'auto'
            document.getElementById('avatar').style.height = 'auto' 

          let attr = img.height>img.width ? 'height' : 'width'
          document.getElementById('avatar').style[attr] = '10vw' 
          this.$emit('onChangeSuccesss', response)
          this.imageUrl = response.url
          }
          
        } else {
          this.$message.error(response.msg)
        }
      },
      // 预览图片
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url
        this.dialogVisible = true
      }
    }
  }
  </script>
  <style >
  .avatar-uploader{
  }
    .avatar-uploader .el-upload {
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background-color: #fbfdff;

    }
   
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
   
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 4vw;
      height:4vw;
      padding: 3vw;
      text-align: center;
    }
   
    .avatar {
      display: block;
    }
   
    .msg {
      font-size: 13px;
      color: #555;
    }
    .avatar_w{

    }
    .avatar_h{

    }
    .loadinger {
  font-size: 0.8rem;
  font-weight: bold;
}
  </style>




// WEBPACK FOOTER //
// src/components/uploader.vue